(function ($) {
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Find marker elements within map.
        var $markers = $el.find(".marker");

        // Create generic map with Map ID.
        var mapArgs = {
            zoom: $el.data("zoom") || 16,
            mapId: "CLINIC_MAP",
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [
                {
                    featureType: "poi",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "transit",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "road",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "administrative",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
            ],
        };
        var map = new google.maps.Map($el[0], mapArgs);

        //console.log("Map initialized with ID:", "CLINIC_MAP");

        // Add markers.
        map.markers = [];
        $markers.each(function () {
            initMarker($(this), map);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        // Get position from marker.
        var lat = parseFloat($marker.data("lat"));
        var lng = parseFloat($marker.data("lng"));
        var latLng = { lat, lng };
    
        //console.log("Initializing marker at position:", latLng);
    
        // Set up icon
        var iconUrl = $marker.attr("data-icon");
        var iconWidth = 51; // Set your icon width
        var iconHeight = 60; // Set your icon height
    
        //console.log("Marker icon URL:", iconUrl);
    
        // Create a DOM element for the marker icon using background image
        var markerContent = document.createElement("div");
        markerContent.style.backgroundImage = `url(${iconUrl})`;
        markerContent.style.width = iconWidth + "px";
        markerContent.style.height = iconHeight + "px";
        markerContent.style.backgroundSize = 'contain';
        markerContent.style.backgroundRepeat = 'no-repeat';
        markerContent.style.pointerEvents = 'auto';
        markerContent.style.cursor = 'pointer';
        markerContent.style.zIndex = '100'; // Ensure it's clickable
    
        // Create AdvancedMarkerElement instance
        var marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: latLng,
            content: markerContent,
        });
    
        //console.log("AdvancedMarkerElement created with content:", markerContent);
    
        // Append to reference for later use
        if (!map.markers) map.markers = [];
        map.markers.push(marker);
    
        // If marker contains HTML, add it to an info window
        if ($marker.html()) {
            // Create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });
    
            //console.log("Info window content:", $marker.html());
    
            // Show info window when marker is clicked
            marker.addListener("click", () => {
                //console.log("Marker clicked. Showing info window.");
                infowindow.open({
                    anchor: marker,
                    map,
                });
            });
        } else {
            //console.log("Marker has no HTML content for info window.");
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            var position = marker.position; // Retrieve the position set directly
            bounds.extend(new google.maps.LatLng(position.lat, position.lng));
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            //console.log("Map centered on single marker.");

        // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
            //console.log("Map fitted to bounds of multiple markers.");
        }
    }

    // Render maps on page load.
    $(document).ready(function () {
        $(".clinic-map__map").each(function () {
            //console.log("Initializing map for element:", this);
            initMap($(this));
        });
    });

})(jQuery);
